<template>
  <div class="text-main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="text-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <span class="title" v-html="item.title"></span>
      <span class="desc">{{ item.summary }}</span>
      <span class="time">{{ Number(item.create_time) | datetimeFormat }}</span>
      <div class="line"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: "/article/" + id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.text-main {
  min-height: calc(100vh - 700px);
}

.text-content {
  display: inline-block;
  width: 663px;
  height: auto;
  margin-top: 30px;
  margin-left: 43px;
  cursor: pointer;

  .title {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 663px;
    height: 110px;
    margin-top: 27px;
    overflow: hidden;
    font-size: 36px;
    font-weight: 500;
    line-height: 55px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;

    ::v-deep span {
      color: rgb(0 71 255 / 100%);
    }
  }

  .desc {
    display: -webkit-box; /* stylelint-disable-line */
    display: -ms-flexbox; /* stylelint-disable-line */
    width: 663px;
    height: 66px;
    margin-top: 19px;
    overflow: hidden;
    font-size: 24px;
    font-weight: 400;
    line-height: 33px;
    color: #333;
    text-overflow: ellipsis;
    word-break: break-all;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .time {
    display: inline-block;
    margin-top: 20px;
    font-size: 24px;
    font-weight: bold;
    color: #666;
  }

  .line {
    width: 663px;
    height: 1px;
    margin-top: 29px;
    background: #ccc;
  }
}
</style>
